export const ids = [
	'each',
	'area',
	'length',
	'height',
	'volume',

	// For material usage
	'coverage',
] as const;
